import { useMutation, useQuery } from '@tanstack/react-query';

import { TextToPayCompletePaymentRequest } from '@m/types/api';
import { heapAddEventProperties } from '@m/utils/heap';
import { PaymentService } from 'apps/pay/services';

export function useVisitDetails(visitCode: string) {
  return useQuery({
    queryKey: ['userVisitDetails', visitCode],
    queryFn: async () => {
      const response = await PaymentService.getVisitDetails({ visitCode });
      if (response) {
        heapAddEventProperties({
          transactionId: response.id,
          siteId: response.site?.id,
          siteName: response.site?.name,
        });
      }
      return response;
    },
  });
}

export function useCompletePayment() {
  return useMutation({
    mutationFn: (params: TextToPayCompletePaymentRequest & { visitCode: string }) =>
      PaymentService.completePayment(params),
  });
}

export function useWrongVehicle() {
  return useMutation({
    mutationFn: ({ visitCode }: { visitCode: string }) =>
      PaymentService.wrongVehicle({ visitCode }),
  });
}
